import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { ProcessorAppIcon, IndividualsAppIcon, PrognosisAppIcon, PortalAppIcon } from '../utils/IconFactory';
import bgImage from './app-switcher-bg.png';
import { getDeviceInfo } from '../utils';
const { isMobile, isTablet } = getDeviceInfo();
export default function AppSwitcher({ current, user, style = {}, plain = false, onLogOut, onClose, t, lang = 'ru', className = '', needAccountSettings = true, needLogOut = true }) {
    const tr = t !== null && t !== void 0 ? t : (v => v);
    React.useEffect(() => {
        const closeByMouse = (e) => {
            if (!e.target.closest('.app-switcher') && !e.target.closest('.app-switcher-button')) {
                onClose === null || onClose === void 0 ? void 0 : onClose(false);
            }
        };
        const closeByEscape = (e) => {
            if (e.key === 'Escape') {
                onClose === null || onClose === void 0 ? void 0 : onClose(false);
            }
        };
        document.addEventListener('click', closeByMouse);
        document.addEventListener('keydown', closeByEscape);
        return () => {
            document.removeEventListener('click', closeByMouse);
            document.removeEventListener('keydown', closeByEscape);
        };
    }, []);
    const appList = React.useMemo(() => [
        {
            name: 'processor',
            url: (!isMobile || isTablet) ? process.env.REACT_APP_PROCESSOR_APP_URL : process.env.REACT_APP_PROCESSOR_MOBILE_APP_URL,
            title: 'Chronos Pro',
            subTitle: t ? tr("chronos.app.components.appSwitcher.processor.subTitle") : "Инструменты для астрологов",
            icon: ProcessorAppIcon
        },
        {
            name: 'individuals',
            url: process.env.REACT_APP_INDIVIDUALS_APP_URL,
            title: "Chronos Plus",
            subTitle: t ? tr("chronos.app.components.appSwitcher.individuals.subtitle") : "Индивидуальные прогнозы",
            icon: IndividualsAppIcon,
            onlyForRu: true
        },
        {
            name: 'prognosis',
            url: process.env.REACT_APP_PROGNOSIS_APP_URL,
            title: t ? tr("chronos.app.components.appSwitcher.prognosis.title") : "Рассвет",
            subTitle: t ? tr("chronos.app.components.appSwitcher.prognosis.subtitle") : "Путь развития личности",
            icon: PrognosisAppIcon,
            onlyForRu: true
        },
        {
            name: 'portal',
            url: process.env.REACT_APP_PORTAL_APP_URL,
            title: t ? tr("chronos.app.components.appSwitcher.portal.title") : "Портал",
            subTitle: t ? tr("chronos.app.components.appSwitcher.portal.subtitle") : "Новости и статьи об астрологии",
            icon: PortalAppIcon,
            onlyForRu: true
        }
    ]
        .filter(app => !(app.onlyForRu === true && lang !== 'ru')), [lang]);
    return _jsxs(Container, { className: `${className} ui-app-switcher`, style: style, children: [(user && !plain) &&
                _jsxs(Header, { children: [(user === null || user === void 0 ? void 0 : user.avatarUrl) && _jsx(Avatar, { size: 72, style: { backgroundImage: `url(${user.avatarUrl})` } }), _jsx("h1", { children: user.name }), _jsx("h2", { children: t ? tr(user.levelOfAstrology) : (user.levelOfAstrology) }), (current !== process.env.REACT_APP_PROFILE_APP_URL && needAccountSettings) &&
                            _jsx(SettingsButton, { color: "transparent", onClick: () => { window.location.href = `${process.env.REACT_APP_PROFILE_APP_URL}`; }, children: t ? tr("general.accountSettings") : "Настройки аккаунта" })] }), _jsx(Content, { children: appList.map(item => {
                    const Icon = item.icon;
                    return _jsx(AppItem, { className: "app-link", onClick: evt => { var _a; evt.stopPropagation(); window.location.href = (_a = item.url) !== null && _a !== void 0 ? _a : ''; }, children: _jsxs("a", { href: item.url, className: "link", children: [_jsx("div", { className: "icon", children: _jsx(Icon, {}) }), _jsxs("div", { className: "data", children: [_jsx("h5", { className: "title", children: item.title }), _jsx("h4", { className: "subtitle", children: item.subTitle })] }), _jsx("div", { className: "controls", children: item.url === current && _jsx("ins", { className: "current" }) })] }) }, item.name);
                }) }), (user && !plain && needLogOut) && _jsx(Footer, { children: _jsx(LogOutButton, { color: "transparent", onClick: onLogOut, children: t ? tr("chronos.app.components.appSwitcher.signOut") : "Выйти из аккаунта" }) })] });
}
const Avatar = styled('span') `
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;

    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    ${props => props.size && css `
      width: ${props.size}px;
      height: ${props.size}px;
    `}
`;
const animateShow = keyframes `
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;
const Container = styled.div `
  display: flex;
  position: absolute;
  flex-direction: column;
  top: 3.93rem;
  width: 18.875rem;
  height: auto;
  border-radius: 6px;
  background-color: var(--workspace-widget-background);
  overflow: hidden;
  animation: ${animateShow} 0.32s var(--easeOutQuart);
`;
const Header = styled.header `
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  padding-top: 2.312rem;
  padding-bottom: 1.125rem;
  background-image: linear-gradient(to bottom, rgba(59, 59, 59, 0) 0%, var(--workspace-widget-background) 7.50rem), url(${bgImage});

  & > h1 {
    margin-top: 1rem;
    margin-bottom: 0;
    font-size: 1.125rem;
    line-height: 1.25rem;
    color: var(--text-primary);
  }

  & > h2 {
    margin-top: 0.2rem;
    margin-bottom: 0;
    font-size: 0.75rem;
    line-height: 0.875rem;
    color: var(--text-third);
  }

  &:after {
    display: block;
    position: absolute;
    content: '';
    width: 16.25rem;
    height: 1px;
    bottom: 0px;
    left: calc((100% - 16.25rem) / 2);
    background-color: var(--element-neutral);
  }
`;
const ButtonContainer = styled.button `
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.75rem;
  color: var(--colors-white);
  transition: background-color ease .3s;

  padding: 0.4375rem 0.625rem;
  border-radius: 3px;
  border: 1px solid var(--element);

  font-size: 0.75rem;
  line-height: 0.875rem;

  background: none; /* Вынести */
  color: var(--text-inverse);

  &:hover{
    opacity: 0.8;
  }
`;
const SettingsButton = styled(ButtonContainer) `
  margin-top: 0.675rem;
`;
const Content = styled.main `
  display: flex;
  position: relative;
  flex-direction: column;
`;
const AppItem = styled.div `
  display: flex;
  position: relative;
  padding: 0.312rem 0.375rem;
  cursor: pointer;

  & .link {
    display: flex;
    box-sizing: border-box;
    flex: 1;
    align-items: center;
    min-height: 4rem;
    max-height: 4rem;
    color: inherit;
    text-decoration: none;

    border: 1px solid transparent;
    border-radius: 4px;
    transition: background-color ease 0.35s, border-color ease 0.5s;

    &:hover {
      background-color: var(--element-neutral);
      border-color: var(--element-neutral);
      border-left: var(--elemetn-left-border);
    }

    &.disabled {
      pointer-events: none;
    }
  }

  & .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.7rem;
    margin-right: 0.8rem;
  }

  & .data {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  & .title {
    margin: 0;
    color: var(--text-primary);
    font-size: 0.875rem;
    line-height: 0.875rem;
  }

  & .subtitle {
    margin: 0;
    margin-top: 0.375rem;
    font-size: 0.75rem;
    line-height: 0.75rem;
    font-weight: normal;
    color: var(--text-third);
  }

  & .controls {
    min-width: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  & .current {
    display: block;
    align-self: flex-end;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: var(--ui-accent-color);
  }
`;
const Footer = styled.footer `
  display: flex;
  height: 4.625rem;
  justify-content: center;
  align-items: center;
`;
const LogOutButton = styled(ButtonContainer) `
  color: var(--circle-houses-special);
  flex: 0;
  white-space: nowrap;
  border-color: rgba(239, 83, 80, 0.25);
`;
